// Components
import { Button, Input, Modal, ActionButton } from "components"

// Third-Party Libraries
import toast from "react-hot-toast"

// Types
import type { ErrorFetch, SuccessFetch } from "types"
// Utils
import { useApi, useToggle } from "utils"

// React
import { Fragment } from "react"
import { PERMISION } from "security"

interface DetailDeleteType {
    asset_id: number
    asset_code:string
    asset_name: string
}


export function DeleteItem(params: {
  item: DetailDeleteType
  onSuccess: () => void
}) {
  // Hooks
  const { isActive, toggle } = useToggle(false)

  return (
    <Fragment>
      <ActionButton.Delete
        permission={PERMISION.ASET_MANAGEMENT.REGISTER.BY_GROUP.DELETE}
        className="text-error"
        onClick={toggle}
      />

      {isActive && (
        <DeleteModal
          onSuccess={params.onSuccess}
          toggle={toggle}
          item={{
            asset_id: Number(params.item.asset_id),
            asset_code: params.item.asset_code,
            asset_name: params.item.asset_name,
          }}
        />
      )}
    </Fragment>
  )
}



function DeleteModal(params: {
  item: DetailDeleteType
  onSuccess: () => void
  toggle: () => void
}) {
  // Hooks
  const api = useApi()
  const { isActive, setActive } = useToggle(false)

  const onDelete = (): void => {
    setActive(true)

    toast.promise(
    api.delete("/assetdepre/delete_asset", { params: { asset_id: params.item.asset_id } }),
      {
        loading: "Loading...",
        success: (res: SuccessFetch<{ message: string }>) => res.data.message,
        error: (err: ErrorFetch<{ message: string }>) => err.response.data.message
      }
    ).then(() => {
      params.toggle()
      params.onSuccess()
    }).catch(() => {
    }).finally(() => {
      setActive(false)
    })
  }

  return (
    <Modal
      isOpen
      title="DELETE ASSET"
      closeModal={params.toggle}
    >
      <Modal.Body className="flex flex-col gap-3">
        <div className="text-error">Are you sure want to delete this data?</div>

        <Input
          disabled
          label="ASSET CODE"
          value={params.item.asset_code}
        />

        <Input
          disabled
          label="ASSET NAME"
          value={params.item.asset_name}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button
          type="button"
          color="error"
          loading={isActive ? "true" : undefined}
          onClick={onDelete}
          permission={"PR014"}
        >
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  )
}